module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.a9e4cbe4.webp";